// Grid > Grid
import React from 'react'
import { GridContainerProps, GridItemProps, gridDefaultProps, GridProps } from './IGrid'
import styled from 'styled-components'

const Grid: React.FC<GridProps & Partial<GridContainerProps> & Partial<GridItemProps>> = ({ children, className }) => (
	<div className={className}>{children}</div>
)
Grid.defaultProps = gridDefaultProps

export default styled(Grid)`
	${({
		container,
		inline,
		columns,
		rows,
		columnGap,
		rowGap,
		justifyItems,
		alignItems,
		justifyContent,
		alignContent
	}) => {
		let result = container ? (inline ? 'display: inline-grid;' : 'display: grid;') : ''

		result += columns ? `\ngrid-template-columns: ${columns};` : ''
		result += rows ? `\ngrid-template-rows: ${rows};` : ''
		result += columnGap ? `\ngrid-column-gap: ${columnGap};` : ''
		result += rowGap ? `\ngrid-row-gap: ${rowGap};` : ''
		result += justifyItems ? `\njustify-items: ${justifyItems};` : ''
		result += alignItems ? `\nalign-items: ${alignItems};` : ''
		result += justifyContent ? `\njustify-content: ${justifyContent};` : ''
		result += alignContent ? `\nalign-content: ${alignContent};` : ''

		return result
	}};
`
